// extracted by mini-css-extract-plugin
module.exports = {"Small":"style_Small__eMxHu","unchecked":"style_unchecked__3wpSi","checked":"style_checked__1CUy2","indeterminate":"style_indeterminate__2qBAS","disabled":"style_disabled__1d8Wx"};